export const GLEBLU = 'Gleblu';

export const PROCESSING_SUBSCRIPTION_QUERY_PARAM = 'processing-subscription';
